<template>
  <!-- Add Payslip Request Modal -->
  <div
    id="add_payslip_request"
    class="modal custom-modal fade"
    role="dialog"
    ref="addPayslipReqModal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Payslip Request</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="addpaysliprequestclose"
            @click="formClear()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit">
            <template v-if="isAdmin">
              <!-- Employee -->
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Employee <span class="text-danger">*</span></label
                >
                <Field
                  name="employee_id"
                  as="select"
                  class="form-control"
                  v-model="form.employee_id"
                  :class="{ 'is-invalid': clientError.includes('employee_id') }"
                  @change="handleChangeEvent('employee_id')"
                >
                  <option value="">Select Employee</option>
                  <option
                    v-for="employee in employeelist"
                    :key="employee.id"
                    :value="employee.id"
                  >
                    {{ employee.first_name }} {{ employee.last_name }}
                  </option>
                </Field>
                <div
                  class="invalid-feedback"
                  v-if="clientError.includes('employee_id')"
                >
                  Employee is required
                </div>
              </div>
            </template>

            <!-- Month -->
            <div class="input-block mb-3">
              <label class="col-form-label">
                Month <span class="text-danger">*</span>
              </label>
              <Field
                name="month"
                as="select"
                class="form-control"
                v-model="form.month"
                :class="{
                  'is-invalid': clientError.includes('month'),
                }"
                @change="handleChangeEvent('month')"
              >
                <option value="">Select Month</option>
                <option v-for="(m, i) in months" :key="i" :value="i + 1">
                  {{ m }}
                </option>
              </Field>
              <div
                class="invalid-feedback"
                v-if="clientError.includes('month')"
              >
                Month is required
              </div>
            </div>

            <!-- Year -->
            <div class="input-block mb-3">
              <label class="col-form-label">
                Year <span class="text-danger">*</span>
              </label>
              <Field
                name="year"
                as="select"
                class="form-control"
                v-model="form.year"
                :class="{
                  'is-invalid': clientError.includes('year'),
                }"
                @change="handleChangeEvent('year')"
              >
                <option value="">Select Year</option>
                <option v-for="y in years" :key="y" :value="y">
                  {{ y }}
                </option>
              </Field>
              <div class="invalid-feedback" v-if="clientError.includes('year')">
                Year is required
              </div>
            </div>

            <!-- Reason -->
            <div class="input-block mb-3">
              <label class="col-form-label">Reason</label>
              <Field
                name="reason"
                as="textarea"
                class="form-control"
                v-model="form.reason"
                rows="2"
              />
            </div>

            <!-- ADMIN ONLY FIELDS -->
            <template v-if="isAdmin">
              <!-- Status -->
              <div class="input-block mb-3">
                <label class="col-form-label">Status</label>
                <Field
                  name="status"
                  as="select"
                  class="form-control"
                  v-model="form.status"
                >
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </Field>
              </div>

              <!-- Remarks -->
              <div class="input-block mb-3">
                <label class="col-form-label">Remarks</label>
                <Field
                  name="remarks"
                  as="textarea"
                  class="form-control"
                  v-model="form.remarks"
                  rows="2"
                />
              </div>

              <!-- Upload file (only if Approved) -->
              <div class="input-block mb-3" v-if="form.status === 'approved'">
                <label class="col-form-label">Upload Payslip</label>
                <input
                  name="payslip_file"
                  type="file"
                  class="form-control"
                  @change="handleFileUpload($event)"
                  :class="{
                    'is-invalid': clientError.includes('payslip_file'),
                  }"
                  accept=".doc, .docx, .pdf"
                  ref="attachments"
                  :key="fileInputKey"
                />
                <div
                  class="invalid-feedback"
                  v-if="clientError.includes('payslip_file')"
                >
                  Payslip is required when status is approved
                </div>
              </div>
            </template>

            <!-- Submit -->
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Add Payslip Request Modal -->

  <!-- Import Payslip Modal -->
  <div
    id="import_payslip"
    class="modal custom-modal fade"
    role="dialog"
    ref="importPayslipModal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Import Payslips</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="importpayslipclose"
            @click="importClear"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onImport">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >File <span class="text-danger">*</span>
              </label>
              <Field
                name="payslip_import_file"
                type="file"
                class="form-control"
                :class="{
                  'is-invalid': clientError.includes('payslip_import_file'),
                }"
                @change="handleFileImport($event)"
                accept=".xlsx,.xls"
                ref="importPayslipFile"
                :key="importFileInputKey"
              />
              <div
                class="invalid-feedback"
                v-if="clientError.includes('payslip_import_file')"
              >
                Import file is required.
              </div>
            </div>
            <p>
              <a :href="user_demo_file" target="_blank">Click here </a>
              for download Demo file
            </p>
            <small class="form-text text-muted mt-2 d-block">
              <i class="fas fa-info-circle me-1"></i>
              <strong>Note:</strong>
              <ul class="mt-1 mb-0 ps-4">
                <li>
                  1. <strong>Employee ID</strong> should belong to an existing
                  user.
                </li>
                <li>
                  2. To check the <strong>Employee ID</strong>, please
                  <a href="javascript:void(0)" @click="goToEmployeesList"
                    >click here</a
                  >.
                </li>

                <li>
                  3. <strong>Month</strong> should be a number between 1 and 12.
                </li>
                <li>
                  4. The <strong>File Name</strong> must include the extension
                  (e.g., <code>emp_aug_payslip.docx</code>).
                </li>
                <li>
                  5. If your Excel file is currently open, please
                  <strong>Save and Close it first</strong> before selecting for
                  import. Otherwise, the system may show a
                  <strong>Server Error</strong>.
                </li>
              </ul>
            </small>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Import Payslip Modal -->

  <!-- Payslip Upload Modal-->
  <div
    id="upload_payslip"
    class="modal custom-modal fade"
    role="dialog"
    ref="uploadPayslipModal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload Payslip</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="uploadclose"
            @click="uploadClear"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onUpload">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >File <span class="text-danger">*</span>
              </label>
              <Field
                name="payslip"
                type="file"
                class="form-control"
                :class="{
                  'is-invalid': clientError.includes('payslip'),
                }"
                @change="handleUpload($event)"
                accept=".pdf,.doc,.docx"
                ref="uploadFile"
                :key="uploadFileInputKey"
              />
              <div
                class="invalid-feedback"
                v-if="clientError.includes('payslip')"
              >
                Payslip is required.
              </div>
            </div>

            <div class="input-block mb-3">
              <label class="col-form-label">Remark</label>
              <Field
                name="remark"
                as="textarea"
                value=""
                class="form-control"
                v-model="upload_remark"
                rows="3"
              />
            </div>

            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Payslip Upload Modal-->

  <!-- Payslip Zip Upload Modal-->
  <div
    id="upload_payslip_zip"
    class="modal custom-modal fade"
    role="dialog"
    ref="uploadPayslipZipModal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload Payslips</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="zipuploadclose"
            @click="zipUploadClear"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onZipUpload">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >File <span class="text-danger">*</span>
              </label>
              <Field
                name="zip_payslip"
                type="file"
                class="form-control"
                :class="{
                  'is-invalid': clientError.includes('zip_payslip'),
                }"
                @change="handleZipUpload($event)"
                accept=".zip"
                ref="zipUploadFile"
                :key="uploadZipFileInputKey"
              />
              <div
                class="invalid-feedback"
                v-if="clientError.includes('zip_payslip')"
              >
                File is required.
              </div>
            </div>
            <small class="form-text text-muted mt-2 d-block">
              <i class="fas fa-info-circle me-1"></i>
              <strong>Note:</strong>
              <ul class="mt-1 mb-0 ps-4">
                <li>
                  1. Only <strong>.zip</strong> file format is allowed for
                  upload.
                </li>
                <li>
                  2. The ZIP file should contain
                  <strong>only payslip files</strong> — no folders or any other
                  documents.
                </li>
                <li>
                  3. Each payslip file name
                  <strong>must exactly match</strong> the payslip file column
                  mentioned in the import sheet.
                </li>
                <li>
                  4. Do not include any <strong>subfolders</strong> inside the
                  ZIP file; all files should be placed directly in the root.
                </li>
                <li>
                  5. Ensure all payslip files are in
                  <strong>valid document formats</strong> such as
                  <code>.pdf</code> or <code>.docx</code> etc.
                </li>
                <li>
                  6. The total ZIP file size should not exceed
                  <strong>50 MB</strong>, as per the system upload limit.
                </li>
                <li>
                  7. Make sure the ZIP file is
                  <strong>not password-protected</strong> and all files inside
                  are accessible.
                </li>
              </ul>
            </small>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Payslip Zip Upload Modal-->

  <!-- Approve Payslip Request Modal -->
  <div class="modal custom-modal fade" id="approve_payslip" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Update Status</h3>
            <p>Are you sure want to update this payslip request?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary continue-btn"
                  @click="updateStatus"
                  >Update</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
                  ref="updatepayslipclose"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Approve Payslip Request Modal -->

   <!-- Delete Payslip Modal -->
  <div class="modal custom-modal fade" id="delete_payslip" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Payslip</h3>
            <p>Are you sure want to delete?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary continue-btn"
                  @click="deletePayslipConfirm"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
                  ref="deletepayslipclose"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Payslip Modal -->

</template>

<script>
import { notification } from "ant-design-vue";
import axios from "axios";
import { Form, Field } from "vee-validate";

export default {
  components: { Form, Field },

  emits: ["update-payslip-status", "reload-data"],
  props: {
    update_id: {
      type: [Number, String],
      default: null,
    },
    update_status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isAdmin: false,
      form: {
        employee_id: "",
        month: "",
        year: "",
        reason: "",
        status: "approved",
        remarks: "",
        payslipFile: null,
      },
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      years: [],
      employeelist: [],
      clientError: [],
      upload_remark: "",
      payslip: null,
      importFile: null,
      zipFile: null,
      fileInputKey: 0,
      uploadFileInputKey: 0,
      uploadZipFileInputKey: 0,
      importFileInputKey: 0,
    };
  },
  computed: {
    user_demo_file() {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}sample/payslip.xlsx`;
    },
  },
  methods: {
    goToEmployeesList() {
      if (this.$refs.importpayslipclose) {
        this.$refs.importpayslipclose.click();
      }

      document.body.classList.remove("modal-open");
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((el) => el.remove());

      this.$router.push({ path: "/employees-list" });
    },
    handleFileImport(event) {
      this.importFile = event.target.files[0];
      this.handleChangeEvent("payslip_import_file");
    },
    handleFileUpload(e) {
      this.form.payslipFile = e.target.files[0];
      this.handleChangeEvent("payslip_file");
    },
    handleUpload(e) {
      this.payslip = e.target.files[0];
      this.handleChangeEvent("payslip");
    },
    handleZipUpload(e) {
      this.zipFile = e.target.files[0];
      this.handleChangeEvent("zip_payslip");
    },
    handleChangeEvent(target) {
      this.clientError = this.clientError.filter((item) => item !== target);
    },
    updateStatus() {
      this.$refs.updatepayslipclose.click();
      this.$emit("update-payslip-status", this.update_id, this.update_status);
    },
    deletePayslipConfirm() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .delete(`/payslip/${this.update_id}`)
        .then((response) => {
          notification.open({
            message: response?.data?.message || "Successfully Deleted",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });
          this.$refs.deletepayslipclose.click();
          this.$emit("reload-data");
        })
        .catch((error) => {
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_WARNING_COLOR,
            },
          });
        });
    },
    onImport() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var form = new FormData();
      if (this.importFile) {
        form.append("payslip_import_file", this.importFile);
      } else {
        this.clientError.push("payslip_import_file");
      }

      if (this.clientError.length) {
        loader.hide();
        return;
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      axios
        .post("/payslip/import", form, config)
        .then((response) => {
          this.$refs.importPayslipFile.value = "";
          loader.hide();

          notification.open({
            message: response?.data?.message || "Successfully Imported",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.importpayslipclose.click();
          this.$emit("reload-data");
          this.importClear();
        })
        .catch((error) => {
          this.$refs.importPayslipFile.value = "";
          loader.hide();
          if (error.response) {
            var response = error.response;

            notification.open({
              message: response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    onSubmit() {
      this.clientError = [];

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });
      const formData = new FormData();

      // Validation
      if (this.isAdmin && this.form.employee_id === "")
        this.clientError.push("employee_id");
      if (this.form.month === "") this.clientError.push("month");
      if (this.form.year === "") this.clientError.push("year");

      if (this.isAdmin && this.form.status === "approved") {
        if (this.form.payslipFile) {
          formData.append("payslip_file", this.form.payslipFile);
        } else {
          this.clientError.push("payslip_file");
        }
      }

      if (this.clientError.length) {
        loader.hide();
        return;
      }

      formData.append("month", this.form.month);
      formData.append("year", this.form.year);

      if (this.form.reason) formData.append("reason", this.form.reason);
      if (this.isAdmin) {
        formData.append("employee_id", this.form.employee_id);
        formData.append("status", this.form.status);
        if (this.form.remarks) formData.append("remarks", this.form.remarks);
      }

      axios
        .post("/payslip", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_SUCCESS_COLOR },
          });

          this.$refs.addpaysliprequestclose.click();
          this.$emit("reload-data");

          this.formClear();
        })
        .catch((error) => {
          loader.hide();
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_WARNING_COLOR },
          });
        });
    },
    onUpload() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var form = new FormData();
      if (this.payslip) {
        form.append("payslip", this.payslip);
      } else {
        this.clientError.push("payslip");
      }

      if (this.clientError.length) {
        loader.hide();
        return;
      }

      form.append("remarks", this.upload_remark);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      axios
        .post("/payslip/upload/" + this.update_id, form, config)
        .then((response) => {
          this.$refs.uploadFile.value = "";
          loader.hide();

          notification.open({
            message: response?.data?.message || "Successfully Uplaoded",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.uploadclose.click();
          this.$emit("reload-data");

          this.uploadClear();
        })
        .catch((error) => {
          this.$refs.uploadFile.value = "";
          loader.hide();
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_WARNING_COLOR },
          });
        });
    },
    onZipUpload() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var form = new FormData();
      if (this.zipFile) {
        form.append("zip_file", this.zipFile);
      } else {
        this.clientError.push("zip_payslip");
      }

      if (this.clientError.length) {
        loader.hide();
        return;
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      axios
        .post("/payslip/upload-zip", form, config)
        .then((response) => {
          this.$refs.zipUploadFile.value = "";
          loader.hide();

          notification.open({
            message: response?.data?.message || "Successfully Uplaoded",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.zipuploadclose.click();
          this.$emit("reload-data");

          this.zipUploadClear();
        })
        .catch((error) => {
          this.$refs.zipUploadFile.value = "";
          loader.hide();
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: { background: process.env.VUE_APP_WARNING_COLOR },
          });
        });
    },
    loadAllEmployee(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/employees/allemployees", params)
        .then((response) => {
          this.employeelist = response.data.data;
        })
        .catch((error) => {
          var response = error.response;
          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    formClear() {
      this.form = {
        employee_id: "",
        month: "",
        year: "",
        reason: "",
        status: "approved",
        remarks: "",
        payslipFile: null,
      };
      this.clientError = [];
      this.fileInputKey++;
    },
    uploadClear() {
      this.upload_remark = "";
      this.payslip = null;
      this.clientError = [];
      this.uploadFileInputKey++;
    },
    importClear() {
      this.importFile = null;
      this.clientError = [];
      this.importFileInputKey++;
    },
    zipUploadClear() {
      this.zipFile = null;
      this.clientError = [];
      this.uploadZipFileInputKey++;
    },
    closeDialog() {
      this.$refs.addpaysliprequestclose.click();
      this.$refs.updatepayslipclose.click();
      this.$refs.uploadclose.click();
      this.$refs.zipuploadclose.click();
      this.$refs.importpayslipclose.click();
    },
  },
  mounted() {
    const role = window.localStorage.getItem("role");
    this.isAdmin = role && role.includes("Admin");

    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 1; i <= currentYear; i++) {
      this.years.push(i);
    }

    this.loadAllEmployee();
    // const payslipModal = document.getElementById("add_payslip_request");
    // payslipModal.addEventListener("hidden.bs.modal", this.formClear);

    // const payslipUploadModal = document.getElementById("upload_payslip");
    // payslipUploadModal.addEventListener("hidden.bs.modal", this.uploadClear);

    if (this.$refs.addPayslipReqModal) {
      this.$refs.addPayslipReqModal.addEventListener(
        "hidden.bs.modal",
        this.formClear
      );
    }
    if (this.$refs.uploadPayslipModal) {
      this.$refs.uploadPayslipModal.addEventListener(
        "hidden.bs.modal",
        this.uploadClear
      );
    }
    if (this.$refs.uploadPayslipZipModal) {
      this.$refs.uploadPayslipZipModal.addEventListener(
        "hidden.bs.modal",
        this.zipUploadClear
      );
    }
    if (this.$refs.importPayslipModal) {
      this.$refs.importPayslipModal.addEventListener(
        "hidden.bs.modal",
        this.importClear
      );
    }
  },
};
</script>
